import { LOAD_ALL_CONTACT, LOAD_SINGLE_CONTACT } from "./ContactList.saga";

export const loadAllContact = (payload) => ({
  type: LOAD_ALL_CONTACT.LOADING,
  payload,
});

export const loadSingleContact = (payload) => ({
  type: LOAD_SINGLE_CONTACT.LOADING,
  payload,
});
